import {_hasProperty} from '../common/helpers/HelperFunc';

export default class SuperPartnerVO {

	/** @type number */
	countQuestions = 0;

	/** @type string */
	companyName = "";

	/** @type string */
	description = "";

	/** @type string */
	city = "";

	/** @type string */
	website = "";

	/** @type string */
	partnerId = "";

	constructor(data) {

		if (_hasProperty(data, 'countQuestions')) {
			this.countQuestions = data.countQuestions;
		}
		if (_hasProperty(data, 'companyName')) {
			this.companyName = data.companyName;
		}
		if (_hasProperty(data, 'description')) {
			this.description = data.description;
		}
		if (_hasProperty(data, 'city')) {
			this.city = data.city;
		}
		if (_hasProperty(data, 'website')) {
			this.website = data.website;
		}
		if (_hasProperty(data, 'partnerId')) {
			this.partnerId = data.partnerId;
		}
	}
}
